(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-mce-sns]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const track = section.querySelector('[data-mce-sns-track]');
      const thumb = section.querySelector('[data-mce-sns-thumb]');
      const videos = [...section.querySelectorAll('.mce-sns__card video')];
      const dialog = section.querySelector('[data-mce-sns-dialog]');
      const stage = section.querySelector('[data-mce-sns-stage]');
      const larges = [...stage.querySelectorAll('video')];
      const close = () => dialog.close();
      const buttons = [...section.querySelectorAll('[data-mce-sns-open]')];
      const dots = section.querySelector('[data-mce-sns-dots]');
      let current = -1;
      const load = i => {
        const v = larges[i];
        if (v && !v.getAttribute('src')) { v.src = buttons[i].dataset.mceSnsOpen; v.muted = true; v.preload = 'auto'; }
        // iOSは一時停止中の動画を黒く描くので、前後の動画も再生させておく
        if (v) { const r = v.play(); if (r) r.catch(() => {}); }
      };
      const activate = index => {
        if (index === current) return;
        current = index;
        [current - 1, current, current + 1].forEach(load);
        // スワイプで切り替えた動画は頭から見せる
        try { larges[current].currentTime = 0; } catch (e) {}
        larges.forEach((v, i) => { if (Math.abs(i - current) > 1) v.pause(); });
        if (dots) [...dots.children].forEach((dot, i) => dot.classList.toggle('is-active', i === current));
      };
      const seek = section.querySelector('[data-mce-sns-seek]');
      let seeking = false, seekRaf = 0;
      const tick = () => {
        const v = larges[current];
        if (seek && v && v.duration && !seeking) {
          seek.value = String(Math.round(v.currentTime / v.duration * 1000));
          seek.style.setProperty('--p', `${v.currentTime / v.duration * 100}%`);
        }
        seekRaf = dialog.open ? requestAnimationFrame(tick) : 0;
      };
      const paint = () => {
        const v = larges[current];
        if (seek && v && v.duration && !seeking) {
          seek.value = String(Math.round(v.currentTime / v.duration * 1000));
          seek.style.setProperty('--p', `${v.currentTime / v.duration * 100}%`);
        }
      };
      larges.forEach(v => v.addEventListener('timeupdate', paint));
      if (seek) {
        seek.addEventListener('pointerdown', () => { seeking = true; });
        seek.addEventListener('input', () => {
          seeking = true;
          const v = larges[current];
          if (v && v.duration) v.currentTime = seek.value / 1000 * v.duration;
          seek.style.setProperty('--p', `${seek.value / 10}%`);
        });
        seek.addEventListener('change', () => { seeking = false; });
        ['pointerup', 'pointercancel', 'touchend'].forEach(t => seek.addEventListener(t, () => { seeking = false; }));
      }
      const indexNow = () => Math.max(0, Math.min(larges.length - 1, Math.round(stage.scrollLeft / stage.clientWidth)));
      stage.addEventListener('scroll', () => {
        if (!dialog.open || !stage.clientWidth) return;
        const i = indexNow();
        load(i - 1); load(i + 1);
        activate(i);
      }, { passive: true });
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => {
          dialog.showModal();
          document.documentElement.classList.add('mce-sns-modal-open');
          current = -1;
          stage.scrollLeft = index * stage.clientWidth;
          activate(index);
          if (!seekRaf) seekRaf = requestAnimationFrame(tick);
        });
      });
      dialog.addEventListener('keydown', event => {
        const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (step) { event.preventDefault(); stage.scrollTo({ left: (current + step) * stage.clientWidth, behavior: 'smooth' }); }
      });
      section.querySelector('[data-mce-sns-close]').addEventListener('click', close);
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
      });
      dialog.addEventListener('close', () => {
        larges.forEach(v => { v.pause(); v.removeAttribute('src'); v.load(); });
        current = -1;
        document.documentElement.classList.remove('mce-sns-modal-open');
        // 閉じた後に開いたボタンへ戻るフォーカスの枠を出さない
        [0, 60, 200].forEach(ms => setTimeout(() => { if (section.contains(document.activeElement)) document.activeElement.blur(); }, ms));
      });
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const ratio = Math.min(1, track.clientWidth / track.scrollWidth);
        thumb.style.width = `${ratio * 100}%`;
        thumb.style.transform = `translateX(${max > 0 ? Math.max(0, track.scrollLeft) / max * (1 - ratio) / ratio * 100 : 0}%)`;
      };
      const play = () => videos.forEach(video => {
        video.muted = true;
        const result = video.play();
        if (result) result.catch(() => {});
      });
      track.addEventListener('scroll', update, { passive: true });
      track.addEventListener('keydown', event => {
        let left;
        if (event.key === 'ArrowRight') left = track.scrollLeft + track.firstElementChild.offsetWidth + 10;
        if (event.key === 'ArrowLeft') left = track.scrollLeft - track.firstElementChild.offsetWidth - 10;
        if (event.key === 'Home') left = 0;
        if (event.key === 'End') left = track.scrollWidth;
        if (left !== undefined) { event.preventDefault(); track.scrollTo({ left, behavior: 'auto' }); }
      });
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) play();
        }, { threshold: 0.05 });
        observer.observe(section);
      }
      document.addEventListener('visibilitychange', () => { if (!document.hidden) play(); });
      update(); play();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
